define([], function () {
    var dictionary = {
        '&amp;'     :   '&',
        '&gt;'      :   '>',
        '&lt;'      :   '<',
        '&quot;'    :   '"',
        '&#39;'     :   "'",
        '&nbsp;'    :   " ",
        "\n"        :   '<br/>'
    };

    var entityToChar = {};
    var charToEntity = {};

    var charKeys = [];
    var entityKeys = [];
    var key, echar;
    for (key in dictionary)
    {
        echar = dictionary[key];
        entityToChar[key] = echar;
        charToEntity[echar] = key;
        charKeys.push(echar);
        entityKeys.push(key);
    }
    var charToEntityRegex = new RegExp('(' + charKeys.join('|') + ')', 'g');
    var entityToCharRegex = new RegExp('(' + entityKeys.join('|') + '|&#[0-9]{1,5};' + ')', 'g');

    var htmlEncodeReplaceFn = function(match, capture) {
        return charToEntity[capture];
    };

    var htmlDecodeReplaceFn = function(match, capture) {
        return (capture in entityToChar) ? entityToChar[capture] : String.fromCharCode(parseInt(capture.substr(2), 10));
    };

    var htmlEncode = function(value) {
        return (!value) ? value : String(value).replace(charToEntityRegex, htmlEncodeReplaceFn);
    };

    var htmlEncodeObj = function (obj) {
        for (var prop in obj)
        {
            if(typeof obj[prop] === "object")
            {
                continue;
            }
            obj[prop] = htmlEncode(obj[prop]);
        }
    };

    var htmlDecode = function(value) {
        return (!value) ? value : String(value).replace(entityToCharRegex, htmlDecodeReplaceFn);
    };

    var batchHtmlEncode = function (array) {
        if(Array.isArray(array))
        {
            for(var index = 0; index < array.length; index++){
                for (var prop in array[index])
                {
                    if(typeof array[index][prop] === "object")
                    {
                        continue;
                    }
                    array[index][prop] = htmlEncode(array[index][prop]);
                }
            }
        }
    };

    return {
        htmlDecode: htmlDecode,
        batchHtmlEncode: batchHtmlEncode,
        htmlEncode: htmlEncode,
        htmlEncodeObj: htmlEncodeObj
    };
});


// WEBPACK FOOTER //
// ./public/base/utils/htmlTransformer.js